import { NgModule } from "@angular/core";
import { EdgeService } from "./edge.service";
import { GraphProcessingService } from "./graph-processing.service";
import { GroupService } from "./group.service";
import { LabelService } from "./label.service";
import { NodeService } from "./node.service";
import { LinqModelToCanvasService } from "./linqmodel.to.canvas.service";
import { LinqsetRepositoryService } from "./linqset-repository.service";
import { FilterService } from "./filter.service";
import { HelpService } from "../help/help-services";
import { PdfService } from "./pdf.service";
import { TemporalService } from "../temporal/temporal.service";
import { BuildModelService } from "./build-model.service";
import { AnalysisService } from "./analysis-service";

@NgModule({
    declarations: [
    ],
    exports: [
    ],
    imports: [
    ],
    providers: [
      EdgeService,
      NodeService,
      GraphProcessingService,
      BuildModelService,
      GroupService,
      LabelService,
      TemporalService,
      LinqModelToCanvasService,
      LinqsetRepositoryService,
      FilterService,
      HelpService,
      PdfService,
      AnalysisService
    ]
  })
  export class ModelServicesModule { }